/**
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */
'use strict';
/* ----- Global Variables ------------------------------------------------------------------------------------------- */
/* localState declared in /src/shared/common.js */
localState.layout = localState.layout || [];
//localState.lang = localState.lang || 'hu';
/* ----- Hold Ready ------------------------------------------------------------------------------------------------- */
//$.holdReady(true);

checkReady();

/* Load Client Fragment Content */
$.get(url_rewrite + 'modules/mod_login.html', _ajaxReadyModClient);

function _ajaxReadyModClient(data) {
    $('.bodycontent').html(data);
    $('main').hide();
    is_ready.html = true;
    //$.holdReady(false);
}

function checkReady() {
    if (is_ready.config && is_ready.html) {
        clearTimeout(waitForReady);
        //$.holdReady(false);
        sharedReady();
        loginReady();
    } else {
        waitForReady = setTimeout(function (){
            checkReady();
        }, 100);
    }
}

function forceLogIn(data) {
    if (data) {
       /* $.post('api/', {
            do: 'logIn',
            data: data[Math.floor(Math.random() * data.length)]
        }, function (res) {
            localStorage.setItem('last_logged_in', res.userid);
        });*/
        location.replace(data[Math.floor(Math.random() * data.length)].hash);
    }
}

/* ----- Process on Document Ready ---------------------------------------------------------------------------------- */
function loginReady() {
    var
        img = new Image(),
        reader = new FileReader(),
        canvasElement = document.getElementById('canvas'),
        canvas = canvasElement.getContext("2d"),
        imageData, code;
    Layout.Init();
    Settings.Init();
    Language.Init();
    Modal.Init();

    getTranslationsWithoutLogin();

    Modulsettings.Init();

    Kiosk.addCameraListener('qr', processQr);

    $('select.changeLang')
        .val(localState.lang)
        .on('change', function () {
            Language.Init(this.value);
            createForm();
        });
    $('button.qrcode').on('click', function () {
        Kiosk.readqr();
        //$('input[name=qrcode]').trigger('click');
    });
    $('input[name=qrcode]').on('change', evtChangeInput);
    $('#formLogin').on('submit', evtSubmitForm);
    $('#formReg').on('submit', createUser);
    $('#formLostPass').on('submit', lostPass);
    $('#formChangePass').on('submit', changePass);
    $('#formTwofactor').on('submit', twoFactor);

    $('a.lostpass').on('click', function () {
        $("#formLogin").hide();
        $("#formReg").hide();
        $("#formLostPass").show();
    });

    $('a.login').on('click', function () {
        $("#formLogin").show();
        $("#formReg").hide();
        $("#formLostPass").hide();
        $("#formTwofactor").hide();
    });

    $('a.resend_twofactor').on('click', function () {
        $.post('api/', {
            do: 'resendTwoFactor'
        }, function (res) {
            Modal.alert(Language.getItem(res.message));
        });
    });

    $("#formLogin .registration, #formLostPass .registration").on("click", function(){
        location.replace("registration.html");
    });

    $(".twofactor input").on("keyup", function (e){
        e.preventDefault();
        var keycode = e.keyCode || e.which;
        if (keycode == 8) {
            $(this).closest(".twofactor").prev(".twofactor").find("input").focus();
        }

        if ($(this).val() != "") {
            $(this).closest(".twofactor").next(".twofactor").find("input").focus();
        }
    });

    createForm();

    function createUser(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        formData += "&do=createUser";

        $.post('api/', formData, function (res) {
            if (res.error != undefined) {
                if (res.msg_type != "langfile") {
                    Modal.alert(res.message[localState.lang].error_msg);
                } else {
                    Modal.alert(Language.getItem(res.message));
                }
                $('#formReg').removeClass("disabled");
            } else {
                if (!res) {
                    Modal.alert(Language.getItem('login-error'));
                } else {
                    localStorage.setItem('last_logged_in', res.hash);
                    if (res.id) {
                        location.replace(res.hash);
                    }
                }
            }
        });
    }

    function evtSubmitForm(e) {
        e.preventDefault();
        var
            formData = $(this).serializeObject();
        $.post('api/', {
            do: 'logIn',
            data: formData
        }, function (res) {
            if (res.error != undefined) {
                Modal.alert(Language.getItem(res.message));
            } else {
                if (!res) {
                    Modal.alert(Language.getItem('login-error'));
                } else {
                    if (res.twofactor == "twofactor") {
                        $("#formLogin").hide();
                        $("#formTwofactor").show();
                    } else {
                        localStorage.setItem('last_logged_in', res.qrcode);
                        localStorage.setItem('rca4_current_channel', res.default_channel || "ch0");
                    }
                }
            }
        });
    }

    function twoFactor(e) {
        e.preventDefault();

        var formData = $(this).serializeObject();

        $.post('api/', {
            do: 'twoFactor',
            data: formData
        }, function (res) {
            if (res.error != undefined) {
                Modal.alert(Language.getItem(res.message));
            } else {
                if (!res) {
                    Modal.alert(Language.getItem('login-error'));
                } else {
                    localStorage.setItem('last_logged_in', res.qrcode);
                    localStorage.setItem('rca4_current_channel', res.default_channel || "ch0");
                }
            }
        });
    }

    function lostPass(e) {
        e.preventDefault();
        var
            formData = $(this).serializeObject();
        $.post('api/', {
            do: 'lostPass',
            data: formData
        }, function (res) {
            if (res.error) {
                Modal.alert(Language.getItem(res.message));
            } else {
                Modal.alert(Language.getItem('lostpass-sent'), function () {
                    location.reload();
                });
            }
        });
    }

    function evtChangeInput(e) {
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = function () {
                img.src = this.result;
                img.onload = function () {
                    canvasElement.width = 1080;
                    canvasElement.height = canvasElement.width * (this.height / this.width);
                    canvas.drawImage(this, 0, 0, canvasElement.width, canvasElement.height);
                    imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
                    code = jsQR(imageData.data, imageData.width, imageData.height, {
                        /*inversionAttempts: "dontInvert"*/
                    });
                    if (code && code.data) {
                        if (Number(code.data) >= 1001 && Number(code.data) <= 199999) {
                            var
                                $form = $('#formLogin');
                                $form.find('input[name=user]').val(Number(code.data));
                                $form.find('input[name=pwd]').val('e');
                                $form.trigger('submit');
                                $form = null;
                        } else {
                            Modal.alert('QR kód nem tartalmaz belépési információt.');
                        }
                    } else {
                        Modal.alert('QR kód olvasása nem sikerült.');
                    }
                };
            };
        }
    }

    if (location.hash) {
        let hashtag = location.hash.replace("#", "");
        history.pushState("", document.title, window.location.pathname);

        if (hashtag == "twofactor") {
            $("#formLogin").remove();
            $("#formLostPass").remove();
            $("#formReg").remove();
            $("#formChangePass").remove();
            $("#formTwofactor").show();
        } else {
            $("#formLogin").remove();
            $("#formLostPass").remove();
            $("#formReg").remove();
            $.ajax({
                url: 'api/',
                method: 'post',
                data: {
                    do: "checkLostPass",
                    hash: hashtag
                },
                success: function (response) {
                    if (response.error) {
                        location.reload();
                    } else {
                        $('#formChangePass [name="lostpass_hash"]').val(hashtag);
                    }
                }
            });
        }
    } else {
        $("#formChangePass").remove();
    }

    function changePass(e) {
        e.preventDefault();
        var
            formData = $(this).serializeObject();
        $.post('api/', {
            do: 'changePass',
            data: formData
        }, function (res) {
            if (res.error) {
                Modal.alert(Language.getItem(res.message));
            } else {
                Modal.alert(Language.getItem('changepass-success'), function(){
                    location.reload();
                });
            }
        });
    }
}

function getRegistrationData() {
    $.ajax({
        method: 'post',
        url: 'api/',
        data: {
            do: 'getRegistrationData'
        },
        success: function (resp) {
            AppData.registration = resp;
            createForm();
        }
    });
}

function createForm() {
    switch (AppData.registration.login_type) {
        case "non-sec-plus":
            $("#formLogin").hide();
            $("#formReg").show();
            var regform = $("#formReg");
            var fields_container = $(".fields", regform);

            fields_container.empty();

            for (var f in AppData.registration.fields) {
                var field = AppData.registration.fields[f];

                var p = $("<p/>");
                var label = $("<label/>").addClass("inputgroup flex");
                var i = $("<i/>").addClass(field.icon);
                var input;

                if (field.userfield != "") {
                    input = $("<input/>").attr("name", field.userfield).attr("placeholder", field.label[localState.lang].text);
                    if (field.required) {
                        input.attr("required", "required");
                    }
                    if (field.userfield == "password") {
                        input.attr("type", "password");
                    }
                    if (field.userfield == "email") {
                        input.attr("type", "email");
                    }
                } else if (field.dynamic_user_field != "") {
                    let dufield = AppData.user_fields.find(function (item) {
                        return item.id == field.dynamic_user_field;
                    });
                    input = $("<input/>").attr("name", "values["+dufield.id+"]").attr("placeholder", dufield.label[localState.lang]);
                    if (field.required) {
                        input.attr("required", "required");
                    }
                } else {
                    switch (field.customfield) {
                        case "select":
                            input = $("<select/>").attr("name", field.fieldname);
                            let empty_option = $("<option/>").val("").text(field.label[localState.lang].text);

                            input.append(empty_option);

                            for (let i = 0; i < field.options_num; i++) {
                                let option = $("<option/>").val(field.options.value[i]).text(field.options[localState.lang].label[i]);
                                input.append(option);
                            }

                            break;
                        case "text":
                        default:
                            input = $("<input/>").attr("name", field.fieldname).attr("placeholder", field.label[localState.lang].text);
                            break;
                    }
                    if (field.required) {
                        input.attr("required", "required");
                    }
                }

                label.append(i);
                label.append(input);
                p.append(label);

                fields_container.append(p);
            }

            break;
        case "non-sec":
            $("#formReg").hide();
            $("#formLogin").show();
            if (AppData.registration.default_user) {

                $.ajax({
                    method: 'post',
                    url: 'api/',
                    data: {
                        do: "userExists",
                        id: AppData.registration.default_user
                    },
                    success: function (resp) {
                        if (resp.exists == true) {
                            location.replace(AppData.registration.default_user);
                        }
                    }
                });
            }
            break;
        case "basic-easy":
        case "basic":
        default:
            $("#formReg").hide();
            $("#formLogin").show();

            if (AppData.registration.default_user) {

                $.ajax({
                    method: 'post',
                    url: 'api/',
                    data: {
                        do: "userExists",
                        id: AppData.registration.default_user
                    },
                    success: function (resp) {
                        if (resp.exists == true) {
                            $("[name='user']").val(resp.email);
                            $("[name='pwd']").val(AppData.registration.default_user);
                        }
                    }
                });
            }

            if (AppData.registration.reg_allowed == 1) {
                $("#formLogin .registration").show();
            } else {
                $("#formLogin .registration").hide();
            }

            break;

    }
}

function processQr(code) {

    $.post('api/', {
        do: 'logInByQR',
        data: {
            code: code
        }
    }, function (res) {
        if (!res) {
            Modal.alert(Language.getItem('login-error'));
        } else {
            localStorage.setItem('last_logged_in', res.userid);
        }
    });
}

function loginLastUser() {
    $.post('api/', {
        do: 'loginByID',
        data: {
            uid: localStorage.getItem('last_logged_in')
        }
    }, function (res) {
        if (!res) {
            Modal.alert(Language.getItem('login-error'));
        } else {
            localStorage.setItem('last_logged_in', res.userid);
        }
    });
}

function getTranslationsWithoutLogin() {
    $.post('api/', {
        do: 'getTranslationsWithoutLogin'
    }, function (data) {
        data.sort(function(a,b) {
            return parseInt(a.sort_id) > parseInt(b.sort_id) ? 1 : -1;
        });
        var loginlanguagesFragment = $(document.createDocumentFragment());
        $.each(data, function(i,e) {
            if(e.active)
                $("<option/>").val(e.translation_id).text(e.translation_name).attr('selected', localState.lang == e.translation_id).appendTo(loginlanguagesFragment);
        });
        $("#landing").find(".changeLang").html(loginlanguagesFragment);

        var actlang = data.find(function (item) {
            return item.translation_id == localState.lang;
        });

        if (actlang == undefined) {
            Language.Init(AppData.settings.lang);
        }

        data = null;
    })
}
